import * as React from 'react';

import { LocalizedComponentProps, withLocalization } from '@shared-ui/localization-context';

import { SearchCriteriaModel } from 'stores/models';

import { UitkCheckbox } from 'uitk-react-checkbox';
import { UitkLayoutGridItem } from 'uitk-react-layout-grid';

import { FormFieldBinding } from 'src/common/components/common/search-form/fields/form-field-binding';
import { SearchFormFieldProps } from 'src/common/components/common/search-form';

interface PartialStayCheckboxProps extends LocalizedComponentProps, SearchFormFieldProps {
  model: SearchCriteriaModel;
}

// @ts-ignore
@withLocalization
@FormFieldBinding
export class PartialStayCheckbox extends React.Component<PartialStayCheckboxProps> {
  private readonly name: string;
  private readonly label: string;

  constructor(props: PartialStayCheckboxProps) {
    super(props);

    this.name = props.modelKey;
    this.label = props.l10n.formatText('multiItem.searchWizard.partialStay.text');

    this.handleChange = this.handleChange.bind(this);
  }

  private handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    const { updateModel } = this.props;

    if (typeof updateModel === 'function') {
      const { checked } = event.target;

      updateModel({
        target: {
          name: 'partialStay',
          value: String(checked),
          track: true,
        },
      });
    }
  }

  public render() {
    const { model } = this.props;

    return (
      <UitkLayoutGridItem colSpan="all">
        <div>
          <UitkCheckbox
            id={this.name}
            name={this.name}
            value={String(model.isPartialStay)}
            checked={model.isPartialStay}
            onChange={this.handleChange}
          >
            {this.label}
          </UitkCheckbox>
        </div>
      </UitkLayoutGridItem>
    );
  }
}
